<template>
  <div class="chip-list-container d-flex flex-column">
    <span v-if="hasTitle" class="chip-list-title"> {{ title }}</span>
    <div v-if="!onlyDialog" class="chip-list">
      <span v-if="!items.length && !buttonActivator" class="no-data-test">Não existem dados a serem exibidos.</span>
      <div v-else>
        <v-chip-group show-arrows active-class="primary--text" :column="showAll">
          <template>
            <v-chip v-for="(item, index) in items" :key="`${item}-${index}`" small :disabled="disabled">
              <span
                ><strong>{{ item }}</strong></span
              >
            </v-chip>
          </template>
        </v-chip-group>
      </div>
    </div>
    <mf-button v-if="buttonActivator" class="activate-button" :disabled="disabled" :label="buttonActivatorLabel" @click="changeDialog" />
    <div v-if="!disabled && items.length && !buttonActivator">
      <span v-if="detailsType === 'list'" class="link" @click="showAll = !showAll">{{ showAll ? 'Minimizar' : 'Mostrar tudo' }}</span>
      <span v-else class="link" @click="dialog = !dialog">Ver lista completa</span>
    </div>
    <chip-list-dialog
      v-if="detailsType === 'dialog' && variant === 'products'"
      v-model="dialog"
      :title="dialogTitle"
      :description="dialogDescription"
      use-link
      :items="products"
      :disabled="disabled"
      :headers="useDefaultHeaders ? productsHeaders : headers"
      searchPlaceholder="Buscar produto"
      link-url="/produtos/detalhes-produto/"
      :disable-items-selection="disableItemsSelection"
      :selected-items-limit="selectedItemsLimit"
      :dialog-width="dialogWidth"
      :selected-items.sync="localSelectedItems"
      item-key="sku"
      @selected-items="emitSelectedItems"
    />
    <chip-list-dialog
      v-if="detailsType === 'dialog' && variant === 'units'"
      v-model="dialog"
      :title="dialogTitle"
      :description="dialogDescription"
      searchPlaceholder="Buscar loja"
      :items="units"
      :headers="useDefaultHeaders ? unitsHeaders : headers"
      :disabled="disabled"
      :dialog-width="dialogWidth"
      @selected-items="emitSelectedItems"
    />
  </div>
</template>

<script>
import ChipListDialog from './ChipListDialog.vue'
export default {
  name: 'ChipList',
  components: {
    ChipListDialog,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    dialogDescription: {
      type: String,
      default: '',
    },
    dialogTitle: {
      type: String,
      default: '',
    },
    dialogWidth: {
      type: String,
      default: '515px',
    },
    variant: {
      type: String,
      default: 'units',
      validator: (value) => ['units', 'products'].includes(value),
    },
    detailsType: {
      type: String,
      default: 'list',
      validator: (value) => ['list', 'dialog'].includes(value),
    },
    buttonActivator: {
      type: Boolean,
      default: false,
    },
    buttonActivatorLabel: {
      type: String,
      defult: 'Ver lista completa',
    },
    disableItemsSelection: {
      type: Boolean,
      default: false,
    },
    selectedItemsLimit: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    products: {
      type: Array,
      default: () => [],
    },
    units: {
      type: Array,
      default: () => [],
    },
    useDefaultHeaders: {
      type: Boolean,
      required: false,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    onlyDialog: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showAll: false,
    dialog: false,
    unitsHeaders: [
      {
        text: 'Loja',
        value: 'unit',
        width: '100%',
      },
    ],
    productsHeaders: [
      {
        text: '',
        value: 'image',
        width: '20%',
      },
      {
        text: 'Nome',
        value: 'name',
        width: '80%',
      },
    ],
  }),
  computed: {
    localSelectedItems: {
      get() {
        return this.selectedItems
      },
      set(value) {
        this.$emit('update:selected-items', value)
      },
    },
    hasTitle() {
      return this.title?.length > 0
    },
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    emitSelectedItems(items) {
      this.$emit('selected-items', items)
    },
  },
}
</script>

<style lang="scss" scoped>
.chip-list-container {
  gap: 5px;
  .chip-list-title {
    font-weight: 700;
    color: $cinza-d10;
    font-size: 18px;
  }
  .chip-list {
    .no-data-test {
      font-size: 16px;
      color: $cinza-0;
      font-weight: 400;
      line-height: 120%; /* 19.2px */
      letter-spacing: 0.4px;
    }
  }
  .activate-button {
    width: 315px;
    padding: 10px 16px;
    margin-bottom: 10px;
  }
}
</style>
